/**
 * Custom fetch client for the OAuth server.
 *
 * No 401 handling here by design: this client is the one refreshAuthTokens()
 * itself calls (see @medme/auth createAuthFlow) — a self-refresh would recurse.
 */

import { createApiClient } from "@medme/api-client"
import { getAppConfig } from "@/app/config/app-config"

export type { BodyType, ErrorType } from "@medme/api-client"

const apiClient = createApiClient({
	getBaseUrl: () => getAppConfig().oauthUrl,
})

/**
 * Обёртка над apiClient, а не прямой реэкспорт: orval статически парсит
 * этот файл и требует, чтобы экспорт был объявлен функцией с параметрами.
 */
export const customFetch = <T>(url: string, options: RequestInit): Promise<T> =>
	apiClient<T>(url, options)

export default customFetch
